import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloorDetectionHalfautomatisch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M10.789,20.956c-1.829,0.027 -7.137,0 -7.137,0c-0.943,0 -1.707,-0.812 -1.707,-1.822l0,-8.206c0,-0.538 0.222,-1.048 0.605,-1.388l5.966,-5.467c0.64,-0.576 1.565,-0.576 2.205,0l5.975,5.467c0.382,0.349 0.605,0.859 0.605,1.388",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M4.417,11.24l10.59,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M11.253,16.393l-6.837,-0.016",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
			id: "Laag-1",
			"serif:id": "Laag 1",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M22.426,13.879l-7.613,0l-2,8.223l7.613,0l2,-8.223Z",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}) })
	]
});
export default SvgFloorDetectionHalfautomatisch;
